<template>
  <h1 >Rogue Transactions</h1>
  <div id="page-rfid-dashboard" class="content-section">
    <div class="page-section">

      <div class="row">
          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Go Back"
                  input-class="$reset btn-rfid-xsm btn btn-rfid btn-associate btn-goback"
                  @click="goTo('Dashboard')"
                  prefix-icon="arrowLeft"
                  prefix-icon-class="btn-rfid-back"
              ></FormKit>
            </div>
          </div>
        </div>


      <div class="clearfix"></div>

      <div class="content-section">
        
        <div class="row">
          <div class="col-md-3">
            <FormKit
              v-model="selectedStatus"
              type="radio"
              :options="{
                '0': 'Unresolved',
                '-': 'All'
              }"
              name="status"
              options-class="radio-inline"
            />
          </div>

        </div>
        <div class="row mb-5" >
          <div class="col-md-3">
            <div class="formkit-inner">
              <input
                name="search_field"
                type="text"
                class="formkit-input"
                placeholder="Search"
                v-model="searchValue"
                @keyup.enter="applyFilter"
                @input="applyFilter" 
              />
            </div>
         
          </div>
           <div class="col-md-3">
              <div class="mt-2">
                <button @click="clearFilter" id="clearFilter">Clear filter</button>
              </div>
           </div>
           
        </div>

        <div>
          <easy-data-table
              v-model:server-options="serverOptions"
              :server-items-length="serverItemsLength"
              :headers="headers"
              :items="rogueLogs"
              :search-field="searchField"
              :search-value="searchValue"
              :loading="loading"
              alternating
              border-cell
              buttons-pagination
              multi-sort
              server-mode
          >
            <template #empty-message>
              nothing here for the moment
            </template>


            <template #item-rogue_status_time="item">
              <router-link :to="{ name: 'ViewRogueTransaction', params: { id: item.order_id } }">
                <div > {{formatLondon(item.rogue_status_time)}}</div>
              </router-link>
            </template>
            <template #item-customername="item">
              <router-link target="_blank" :to="{ name: 'ViewCustomer', params: { id: item.customer_id } }">
                <div >{{ item.customername }}</div>
              </router-link>
            </template>
            <template #item-customer_id="item">
              <router-link target="_blank" :to="{ name: 'ViewCustomer', params: { id: item.customer_id } }">
                <div >{{ item.customer_id }}</div>
              </router-link>
            </template>
            <template #item-order_id="item">
              <router-link target="_blank" :to="{ name: 'ViewOrder', params: { id: item.order_id } }">
                <div >{{ item.order_id }}</div>
              </router-link>
            </template>
            
            <template #loading>
              <font-awesome-icon
                  icon="spinner"
                  size="2x"
                  title="Loading"
                  spin
              >
              </font-awesome-icon>
            </template>
          </easy-data-table>
        </div>
      </div>

    </div>
  </div>


</template>


<script setup>

import {onMounted, ref, watch} from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import RFIDService from "@/services/RFIDService";
import {  formatLondon } from '@/utils/dateUtils';

const rogueLogs =  ref([]);
const headers = [
  { text: "Transaction Timestamp", value: "rogue_status_time", sortable: true  },
  { text: "Account Name", value: "customername", sortable: true },
  { text: "Account ID", value: "customer_id", sortable: true },
  { text: "Order ID", value: "order_id", sortable: true },
  { text: "Quantity", value: "num_items", sortable: true },
];
const searchField = ref("customer_name");
const searchValue = ref("");
const selectedStatus = ref("0");


const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
  page: 1,
  rowsPerPage: 25,
  sortBy: "",
  sortType: "",
  search: "",
  resolved: "0",
});

// Watch for changes in sorting
watch(serverOptions, (newOptions, oldOptions) => {
  
   // If sortBy or sortType is null, treat as "no sort"
  if (!newOptions.sortBy || !newOptions.sortType) {
    // Handle the "no sort" case, e.g., reset to default sort or unsorted
    return;
  }

  // Only apply filter if sortBy or sortType changed
  if (
    newOptions.sortBy !== oldOptions.sortBy ||
    newOptions.sortType !== oldOptions.sortType
  ) {
    applyFilter();
  }
}, { deep: true });


watch(() => serverOptions.value.page, () => {
  applyFilter()
});
watch(() => serverOptions.value.rowsPerPage, () => {
 applyFilter()
});
watch(() => selectedStatus.value, () => {
  serverOptions.value.resolved = selectedStatus.value;
 applyFilter()
});

const clearFilter = () => {
  const updateServerOptions = serverOptions.value;
  searchValue.value = "";
  serverOptions.value = updateServerOptions;

  applyFilter(true);
};

const applyFilter = (resetPage = false) => {
  let updateOptions = serverOptions.value;
  if (typeof searchValue.value != "undefined") {
    updateOptions.search = searchValue.value;
  }
  if (typeof selectedStatus.value != "undefined") {
    updateOptions.resolved = selectedStatus.value;
  }
  if (resetPage) {
    updateOptions.page = 1;
  }
  serverOptions.value = updateOptions;
  loadRFIDrogueLogsList();
};

const goTo = (pageSection, item=false) =>   {
  switch (pageSection) {
    case "Dashboard":
      window.open(
          "/rfid/dashboard",
          "_self"
      );
      break;
    case "NewGarment":
      window.open(
          "/garmenttype",
          "_blank"
      );
      break;
    case "RefreshGarment":
      refreshgarment();
      break;
  }
}
const loadRFIDrogueLogsList = async () => {
  loading.value = true;
  const {
    serverCurrentPageItems,
    serverTotalItemsLength,
  } = await RFIDService.searchRFIDRogueLogsList(serverOptions.value);
  rogueLogs.value = serverCurrentPageItems;
  serverItemsLength.value = serverTotalItemsLength;
  loading.value = false;
}

onMounted(async () => {
  loadRFIDrogueLogsList();

});

</script>


<style >
  .main-section > h1:first-child {
    background: var(--associate-tag-bg-color);
  }
  .error-message {
    color: var(--red-color);
    font-weight: bold;
  }
  .formkit-fieldset{
      border: none!important;
  }
  .radio-inline.formkit-options {
    display: flex!important;
    gap: 20px!important;
  }
  .radio-inline.formkit-options .formkit-option {
    display: flex!important;
    align-items: center!important;
  }
   .radio-inline.formkit-options .formkit-option:last-child {
    margin-bottom: 10px!important;
  }
  .clear-filter-x {

    right: -40px;
    position: absolute;
    cursor: pointer;
    font-size: 1.5rem;

  }
</style>
